<div [style.background]="backgroundColor" [style.height.px]="20" [style.lineHeight.px]="20" [style.textAlign]="'center'">
  {{preText}} {{entityValue}}
</div>
